// extracted by mini-css-extract-plugin
export default {"main":"Vienna_text_main__c9F8i","container":"Vienna_text_container__2frTQ","head":"Vienna_text_head__M1gSi","body":"Vienna_text_body__GQMY+","footer":"Vienna_text_footer__uXXPn"};